import { types } from 'mobx-state-tree';

export const CompanyMemberModel = types.model({
  user_id: types.identifierNumber,
  name: types.string
});

export const JobMemberModel = types.model({
  user_id: types.reference(CompanyMemberModel),
  photo_url: types.maybeNull(types.string),
  initials: types.string,
  name: types.string,
  role: types.string
});
